'use client'

import dynamic from 'next/dynamic'

import { useThemedToast } from '@/src/hooks/ui/useThemedToast'

import { HotelSearchInitialValues, useHotelSearchManager } from './hooks/useHotelSearchManager'

const DesktopHotelSearchForm = dynamic(
    () => import(/* webpackChunkName: "desktop-hotel-search-form" */ './desktopHotelSearchForm'),
    { ssr: true }
)

const MobileHotelSearchForm = dynamic(
    () => import(/* webpackChunkName: "mobile-hotel-search-form" */ './mobileHotelSearchForm/mobileHotelSearchForm'),
    { ssr: true }
)

interface HotelSearchFormProps {
    isMobile: boolean
    /** Seeds the form — the SRP modifier passes the active search; the homepage omits it. */
    initialValues?: HotelSearchInitialValues
    /** Fired after a successful search navigation, so a modifier can close itself. */
    onSearched?: () => void
}

const HotelSearchForm: React.FC<HotelSearchFormProps> = ({ isMobile, initialValues, onSearched }) => {
    const searchManager = useHotelSearchManager(initialValues)
    const { showError } = useThemedToast()

    if (isMobile) {
        return <MobileHotelSearchForm searchManager={searchManager} showError={showError} onSearched={onSearched} />
    }

    return <DesktopHotelSearchForm searchManager={searchManager} showError={showError} onSearched={onSearched} />
}

export default HotelSearchForm
